import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { usePwaInstall } from "@/lib/usePwaInstall";
import { LayoutGrid, Plus, Download, LogOut } from "lucide-react";

export default function MobileNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { canInstall, install } = usePwaInstall();

  if (!user) return null;

  const onDash = pathname === "/dashboard";

  return (
    <nav
      data-testid="mobile-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-t border-[var(--em-line)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3 h-16 items-center">
        <Link
          to="/dashboard"
          data-testid="mobile-nav-home"
          className={`flex flex-col items-center gap-0.5 text-[11px] ${onDash ? "text-[var(--em-clay)]" : "text-[var(--em-ink-soft)]"}`}
        >
          <LayoutGrid size={20} />
          Dashboard
        </Link>
        <button
          data-testid="mobile-nav-new"
          onClick={() => navigate("/events/new")}
          className="flex flex-col items-center gap-0.5 text-[11px] text-[var(--em-ink-soft)]"
        >
          <span className="w-10 h-10 -mt-5 rounded-full bg-[var(--em-clay)] text-white grid place-items-center shadow-lg shadow-[var(--em-clay)]/30">
            <Plus size={20} />
          </span>
          New
        </button>
        {canInstall ? (
          <button
            data-testid="mobile-nav-install"
            onClick={install}
            className="flex flex-col items-center gap-0.5 text-[11px] text-[var(--em-sage)]"
          >
            <Download size={20} />
            Install app
          </button>
        ) : (
          <button
            data-testid="mobile-nav-signout"
            onClick={() => { logout(); navigate("/"); }}
            className="flex flex-col items-center gap-0.5 text-[11px] text-[var(--em-ink-soft)]"
          >
            <LogOut size={20} />
            Sign out
          </button>
        )}
      </div>
    </nav>
  );
}
